import type { FC } from 'react';
import ContactEmail from '@/Module/Contact/Component/ContactUs/contactEmail';
import ContactSocialMedia from '@/Module/Contact/Component/ContactUs/contactSocialMedia';
const TeacherDetailContact: FC = () => {
  return <div className="mx-auto flex max-w-[1024px] flex-wrap items-stretch gap-8 px-6 pb-8 sm:pb-12 xl:gap-12" data-sentry-component="TeacherDetailContact" data-sentry-source-file="TeacherDetailContact.tsx">
      <ContactSocialMedia data-sentry-element="ContactSocialMedia" data-sentry-source-file="TeacherDetailContact.tsx" />
      <ContactEmail data-sentry-element="ContactEmail" data-sentry-source-file="TeacherDetailContact.tsx" />
    </div>;
};
export default TeacherDetailContact;